import { Highlight, Tab, TabList, TabPanel, TabPanels, Tabs, Text, VStack } from '@chakra-ui/react';
import { isAuthenticated } from '@partiu/api/axios';
import { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Logo } from '../../../../../packages/ui/components/atoms/Logo';
import { SectionTitle } from '../../../../../packages/ui/components/atoms/Title';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { LoginForm } from './components/LoginForm';
import { RegisterForm } from './components/RegisterForm';
import { SurfLoginForm } from './components/SurfLoginForm';
import { AdapterLoginForm } from './components/AdapterLoginForm';
import { LoginExClient } from './components/LoginExClient';

export function LoginPage() {
  const navigate = useNavigate();
  const { isIOS, integratedLogin, name, isLogged, metadata, colors } = useTheme();
  const [tabIndex, setTabIndex] = useState(0);
  const [exClient, setExClient] = useState(false);

  const isLoginIntegrated = useMemo(() => !!integratedLogin && integratedLogin !== '', [integratedLogin]);

  const getLoginComponent = () => {
    if (exClient) {
      return <LoginExClient setExClient={setExClient} isNative={isLoginIntegrated} />;
    }

    if (integratedLogin === 'surf') {
      return <SurfLoginForm setExClient={setExClient} />;
    }
    if (integratedLogin === 'adapter' || integratedLogin === 'mk') {
      return <AdapterLoginForm setExClient={setExClient} />;
    }

    return (
      <>
        <LoginForm setExClient={setExClient} isNative={isLoginIntegrated} />
      </>
    );
  };
  if (isAuthenticated()) navigate('/');

  useEffect(() => {
    if (isLogged) {
      navigate('/');
    }
  }, [isLogged]);

  return (
    <VStack
      maxH={'100vh'}
      minH={'100vh'}
      width={{ base: '95%', lg: '500px' }}
      margin={'auto'}
      paddingTop={isIOS ? '95px' : '50px'}
    >
      <Logo height={'90px'} objectFit={'contain'} w={'auto'} />

      <Tabs
        index={tabIndex}
        onChange={setTabIndex}
        isFitted
        width={'100%'}
        paddingTop={'30px'}
        variant="soft-rounded"
        colorScheme="blackAlpha900"
      >
        <TabList width={'100%'} margin="auto" padding="5px" border={'1px solid #d4d4d4'} borderRadius={'40px'}>
          <Tab padding={'8px'} _selected={{ color: 'white', backgroundColor: 'blackAlpha.900' }}>
            Já tenho conta
          </Tab>
          {/*
          {isLoginIntegrated && (
            <Tab padding={'8px'} _selected={{ color: 'white', backgroundColor: 'blackAlpha.900' }}>
              Ex-Cliente
            </Tab>
          )} */}
          <Tab padding={'8px'} _selected={{ color: 'white', backgroundColor: 'blackAlpha.900' }}>
            {metadata?.buttonregistername || 'Registro'}
          </Tab>
        </TabList>
        <TabPanels paddingTop={'20px'}>
          <TabPanel>
            <SectionTitle fontSize={14} fontWeight={600}>
              <Highlight query={name} styles={{ color: 'primaryColor' }}>
                {isLoginIntegrated
                  ? `Baixe seus ebooks e audiobooks disponíveis ${name}.`
                  : 'Faça login com um CPF, CNPJ ou Email vinculado.'}
              </Highlight>
            </SectionTitle>
            {getLoginComponent()}
            <Text marginTop="20px" color="#a9a9a9" fontSize="12px" textAlign={'center'}>
              Esta com problema em logar?{' '}
              <Link
                style={{
                  color: colors.primaryColor,
                }}
                to={'/contato'}
              >
                Clique aqui
              </Link>{' '}
              , entre em contato conosco.
            </Text>
          </TabPanel>
          {/* {isLoginIntegrated && (
            <TabPanel>
              <SectionTitle fontSize={14} fontWeight={600}>
                <Highlight query={name} styles={{ color: 'primaryColor' }}>
                  {`Ex-Clientes ${name} podem acessar seus livros aqui`}
                </Highlight>
              </SectionTitle>
              <LoginForm isNative={false} />
            </TabPanel>
          )} */}
          <TabPanel>
            <RegisterForm />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </VStack>
  );
}
